











 













const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamInvitationErrorAccepted_verifiedInvitation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamInvitation",
      "kind": "LinkedField",
      "name": "teamInvitation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VerifiedInvitationPayload",
  "abstractKey": null
};

(node ).hash = "92c3d2ed081c6884a47d5640a6992430";

export default node;
